module.exports = __webpack_public_path__ + "static/media/bg-menu-yellow.9af5e669.svg";